import axios, { AxiosResponse } from 'axios'
import {
  AgendamentoDtoCreate,
  AgendamentoView,
  DisponibilidadeDia,
  ParamsDisponibilidade,
} from './_models'
import { montaQueryDisponibilidade } from './agendaHelpers'

const API_URL = process.env.REACT_APP_API_URL
const AGENDAMENTOS_URL = `${API_URL}/agendamentos`

/**
 * `GET /agendamentos/disponibilidade` — grade projetada do intervalo.
 *
 * Gate: `hasPermission(#empresa, 'Empresa', 'Agendamento:read')`. A `empresa`
 * enviada é sempre a **do paciente** (é ela que o `AgendamentoServiceImpl.reserva()`
 * usa), nunca a da pessoa logada.
 */
export const getDisponibilidade = (
  params: ParamsDisponibilidade
): Promise<DisponibilidadeDia[]> => {
  return axios
    .get(`${AGENDAMENTOS_URL}/disponibilidade?${montaQueryDisponibilidade(params)}`)
    .then((d: AxiosResponse<DisponibilidadeDia[]>) => d.data)
}

/**
 * `POST /agendamentos` — reserva o horário.
 *
 * Gate: `hasPermission(#dto.paciente, 'Paciente', 'Agendamento:create')`, ou
 * seja, **por paciente** — é o que mantém o escopo de tenant correto ao agendar
 * a partir da ficha dele.
 *
 * Erros esperados: **409** (`AgendaConflitoException`, mensagem sempre genérica)
 * e **422** (`InvalidDataException`), ambos no envelope `{data: {message, errors}}`
 * que `extrairErrosValidacao()` já lê.
 *
 * ⚠️ `POST /agendamentos/hold` **não é usado**: hoje só recusa quando
 * `capacidade_simultanea` não é nula (é nula em todas as empresas) e, no modo
 * nominal, nem consulta a fechadura real `(pessoa, horário)`. Quem garante a
 * vaga é o `select ... for update` do POST.
 */
export const criaAgendamento = (dto: AgendamentoDtoCreate): Promise<AgendamentoView> => {
  return axios.post(AGENDAMENTOS_URL, dto).then((d: AxiosResponse<AgendamentoView>) => d.data)
}

/** `GET /agendamentos/{id}` — detalhe de uma reserva. */
export const getAgendamentoById = (id: number): Promise<AgendamentoView> => {
  return axios.get(`${AGENDAMENTOS_URL}/${id}`).then((d: AxiosResponse<AgendamentoView>) => d.data)
}
